import { formatVnd } from '@/lib/format'
import { cn } from '@/lib/utils'

interface Props {
    /** Id cho ô nhập trỏ tới qua `aria-describedby`. */
    id: string
    /** Giá trị ô nhập đang giữ (số hoặc chuỗi thô). Rỗng / không phải số → trống. */
    value: number | string | undefined
    className?: string
}

function toPreviewText(value: Props['value']): string {
    if (value === undefined) return ''
    if (typeof value === 'string' && value.trim() === '') return ''
    const n = Number(value)
    return Number.isFinite(n) ? formatVnd(n) : ''
}

/**
 * MoneyPreview — dòng nhỏ dưới ô `type="number"` hiển thị số tiền đã tách
 * hàng nghìn (vd `1.500.000 ₫`), vì ô number không cho chèn dấu phân cách.
 *
 * Luôn giữ cố định một dòng (`h-4`, `truncate`) kể cả khi trống, để lúc gõ
 * số form không bị nhảy / xô lệch.
 */
export function MoneyPreview({ id, value, className }: Props) {
    return (
        <p
            id={id}
            data-testid="money-preview"
            className={cn(
                'mt-1 h-4 truncate text-xs leading-4 tabular-nums text-muted-foreground',
                className,
            )}
        >
            {toPreviewText(value)}
        </p>
    )
}
